/* eslint-disable */
/* @flow */

//import liraries
import React, { Component } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Image, TouchableOpacity } from 'react-native'
import { Images } from '../Themes'
import styles from './Styles/BadgeButtonStyles'



// create a component
class BadgeButton extends Component {

   getAsset = (type) => {
    switch (type) {
      case 'camera':
        return Images.camera
      case 'close':
        return Images.crossSmall
      default:
        return null
    }
  }
  
   getStyle = (type) => {
    switch (type) {
      case 'camera':
        return styles.camera
      case 'close':
        return styles.close
      default:
        return styles.default
    }
  }
  render() {
    const {type } = this.props
    const asset = this.getAsset(type)
    const style = this.getStyle(type)
    return (
      <TouchableOpacity
      disabled={!this.props.onPress}
      onPress={this.props.onPress}
      style={[styles.container,style]}>
      <Image source={asset} />
    </TouchableOpacity>
    );
  }
}

export default BadgeButton
